import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ROL_CARGADOR_LISTAS } from "@/lib/nav";

// sep-2026 · Guard de ROL en la ruta, además del candado del backend.
// El rol de plataforma "cargador_listas" solo tiene dos pantallas; si teclea cualquier otra
// URL se le devuelve a su inicio en lugar de mostrarle un cascarón que va a responder 403.
export { ROL_CARGADOR_LISTAS };

export function inicioPara(role) {
  return role === ROL_CARGADOR_LISTAS ? "/admin-listas" : "/dashboard";
}

export function Guard({ permitidos, prohibidos, children }) {
  const { user } = useAuth();
  if (user === null) return null;               // sesión en verificación
  if (!user) return <Navigate to="/login" replace />;
  const role = user.role;
  if (Array.isArray(permitidos) && !permitidos.includes(role)) {
    return <Navigate to={inicioPara(role)} replace />;
  }
  if (Array.isArray(prohibidos) && prohibidos.includes(role)) {
    return <Navigate to={inicioPara(role)} replace />;
  }
  return children;
}
